
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import useLocale from 'next-translate/useTranslation';
// Above-the-fold pieces are imported statically — loading the nav via
// next/dynamic makes the client hydrate a fallback where the server rendered
// the full nav, which is a guaranteed hydration mismatch.
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import MarkyHero from '@/components/marky/MarkyHero';
import Seo from '@/components/Seo';
const MarkyCapabilities = dynamic(() => import('@/components/marky/MarkyCapabilities'));
const MarkyShowcase = dynamic(() => import('@/components/marky/MarkyShowcase'));
const MarkyWebsiteBuilderSection = dynamic(() => import('@/components/marky/MarkyWebsiteBuilderSection'));
const MarkyConnectors = dynamic(() => import('@/components/marky/MarkyConnectors'));
const ChatGPTComparisonNew = dynamic(() => import('@/components/landing/ChatGPTComparisonNew'));
const Testimonials = dynamic(() => import('@/components/Testimonials'), {
    ssr: false,
});
const CallToAction = dynamic(() => import('@/components/CallToAction'));
const Footer = dynamic(() => import('@/components/layout/Footer'));
const MarkyPage = () => {
    const { t, lang } = useLocale('marky');
    return (<main className='relative bg-white dark:bg-slate-950'>
      <Seo templateTitle={t('Marky AI Agent — Build, Browse, Code & Research with AI')} image={lang === 'en'
            ? 'https://easy-peasy.ai/images/marky-chat.jpg'
            : `https://easy-peasy.ai/api/og-template?title=${t('Meet Marky Agent')}&description=${t('AI that takes action, not just answers')}`} description={t('Marky is an AI agent that builds websites, browses the web, runs code, creates presentations, generates images, and performs deep research — powered by GPT, Claude, Gemini, and more.')}/>

      <div className='relative isolate overflow-hidden bg-white dark:bg-slate-950'>
        <div aria-hidden='true' className='pointer-events-none absolute -top-24 left-1/2 h-[500px] w-[800px] -translate-x-1/2 rounded-full bg-indigo-500/10 blur-[120px] dark:bg-indigo-500/15'/>
        <div className='relative'>
          <LandingPageNavigation />
          <MarkyHero />
        </div>
      </div>
      <MarkyCapabilities />
      <MarkyWebsiteBuilderSection />
      <MarkyShowcase />
      <MarkyConnectors />
      <ChatGPTComparisonNew />

      <Testimonials />

      <CallToAction preset='chat'/>
      <Footer />
    </main>);
};
export default MarkyPage;
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a15314eb8a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/marky',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15314eb8a__ as getStaticProps }
  